var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"app":"","fluid":true}},[_c('v-row',[_c('v-col',{staticClass:"pt-0 pb-3",attrs:{"cols":"3"}},[_c('list-storehouses')],1),_c('v-col',{staticClass:"pt-0 pb-3",attrs:{"cols":"9"}},[_c('detail-storehouse')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }